import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DATA_HOOKS } from './dataKeys';
import { inputDriverFactory as coreInputDriverFactory } from '../internal/WixUiCoreComponents/components/CoreInput/CoreInput.uni.driver';
import { DATA_HOOKS as CORE_INPUT_DATA_HOOKS } from '../internal/WixUiCoreComponents/components/CoreInput/dataKeys';
import { dataHook } from '../../testkitUtils/utils';

export interface TextFieldDriver extends BaseUniDriver {
  /** @private @deprecated */
  root: UniDriver;
  input: UniDriver;
  label: UniDriver;
}

export const textFieldDriverFactory = (base: UniDriver): TextFieldDriver => {
  const root = base.$(dataHook(DATA_HOOKS.ROOT));
  const label = root.$(dataHook(DATA_HOOKS.LABEL));
  const coreInput = coreInputDriverFactory(
    base.$(dataHook(CORE_INPUT_DATA_HOOKS.ROOT)),
  );

  return {
    ...baseUniDriverFactory(base),
    root,
    input: coreInput.input,
    label,
  };
};
